var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTickMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "037CECD5-FD88-4FFD-B1FC-1AF1C44C98FF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Dealer---Unauth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.2.2.1-XL_OSB_Short-Journey_EU_Find-dealer-SEARCH-ERROR",
    transform: "translate(-816.000000, -814.000000)",
    stroke: "#008200",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Results",
    transform: "translate(720.000000, 603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(0.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(96.000000, 134.654930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    transform: "translate(0.000000, 2.500000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "15.2870305 3.21348303 5.71399659 12.786517 0.712969468 7.78548985"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTickMark);
export default __webpack_public_path__ + "static/media/success_tick_mark.34e94d70a6df333e83bff2a8602f63bf.svg";
export { ForwardRef as ReactComponent };